import React, { useEffect, useState } from 'react';
import Logo from '../assets/logo.png';
import { Heart, KeyRound, LockKeyhole, LogOut, User } from 'lucide-react';
import { getContent } from '../Functions';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSearchParams } from 'react-router-dom';
import Banner from '../assets/Banner.png'
import { OffCanvas } from './OffCanvas'; // Assuming you have OffCanvas component

export default function Sidebar({ SelectedChannel, onChannelSelect }) {

  const [searchParams, setSearchParams] = useSearchParams();

  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState(0);
  const [isLoggedId, setIsLoggedIn] = useState();

  const [showOffCanvas, setShowOffCanvas] = useState(false);  // Control offcanvas visibility
  const [offCanvasTitle, setOffCanvasTitle] = useState(''); // Title of offcanvas
  const [iframeUrl, setIframeUrl] = useState(''); // URL for iframe in offcanvas

  // Fetch channel from URL and content on mount
  useEffect(() => {

    const user = localStorage.getItem('PK_user');
    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }

    const params = new URLSearchParams(window.location.search);
    const channelParam = parseInt(params.get('channel'), 10);
    setSelectedChannel(Number.isInteger(channelParam) ? channelParam : 0);

    const fetchChannels = async () => {
      const data = await getContent();
      setChannels(data.channels || []);
    };

    fetchChannels();
  }, []);


  const handleChannelClick = (channel, index) => {
    if (window.location.pathname !== "/") {
      window.location.href = "/?channel=" + index;
    } else {
      setSearchParams({ channel: index });
      onChannelSelect(index); // <-- notify parent of selection
    }

  };

  const logout = () => {
    console.log("LL")
    localStorage.removeItem('PK_user');
    setIsLoggedIn(false);
    window.location.href = "/";
  };



  const openOffCanvas = (title, url) => {
    setOffCanvasTitle(title);
    setIframeUrl(url);
    setShowOffCanvas(true);
  };


  return (
    <div>
      <div className="sidebar">
        <img src={Logo} alt="Logo" className="logo py-3" />


        <ul className="sidebar_channels">
          {channels.map((channel, index) => (
            <li
              key={channel.id}
              className={`sidebar_channel sidebar_item ${index === SelectedChannel ? 'active' : ''}`}
              onClick={() => handleChannelClick(channel, index)}
            >
              <LazyLoadImage
                src={channel.bannerImage? channel.bannerImage : Banner} 
                alt={channel.name}
                className="sidebar_channel_image"
                effect="blur"
              />
              <span>{channel.name}</span>
            </li>
          ))}
        </ul>

        <ul className="sidebar_bottom d-flex flex-column">
          {isLoggedId ? <li className="sidebar_item " onClick={() => window.location.href = '/favorites'} ><Heart color="var(--main-red)" /> Favorites</li> : ""}
          {!isLoggedId ? <li className="sidebar_item " onClick={() => openOffCanvas('Terms & Conditions', 'https://pikaboo-terms.netlify.app')} ><KeyRound color="var(--main-red)"  /> Terms & Conditions</li> : ""}
          {!isLoggedId ? <li className="sidebar_item "  onClick={() => openOffCanvas('Privacy Policy', 'https://pikaboo-privacy.netlify.app')} ><LockKeyhole color="var(--main-red)"/> Privacy Policy</li> : ""}


          {isLoggedId ?
            <li className="sidebar_item " onClick={() => logout()} ><LogOut color="var(--main-red)" /> Logout</li>
            :
            <li className="btn btn-primary m-1" data-bs-toggle="modal"
              data-bs-target="#loginModal">
              <User /> Login</li>}
        </ul>



      </div>

      {/* OffCanvas Component */}
      <OffCanvas
        show={showOffCanvas}
        onClose={() => setShowOffCanvas(false)}
        title={offCanvasTitle}
      >
        <iframe src={iframeUrl} width="100%" height="100%" frameBorder="0" title={offCanvasTitle}></iframe>
      </OffCanvas>
    </div>
  );
}
